import { createLocalStorageManager } from '../../utils/storage';

export const lastChosenCampaignLS = createLocalStorageManager<string>('last-chosen-campaign');
